import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import moment from 'moment-timezone';
import IconButton from "@material-ui/core/IconButton";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import TicketAuditReviewLink from "utils/TicketAuditReviewLink";
import {Objects, Parts} from "../index";
import Collections from "./index";
import Search from '@material-ui/icons/Search'
import EngineerHDCard from "../Parts/EngineerHDCard";
import TicketScoreBreakdown from "../Parts/TicketScoreBreakdown";
import {Tooltip} from "@material-ui/core";

export default class HelpDesks7DayMissing extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, "GET_MISSING");
		super(props, model);
		this.state = {
			...this.state,
			search: "",
			field_engineers: null,
			showFinancial: false,
			showDate: false,
			help_desk_contacted_modal: false,
			filterTOS: false,
			filterDate: moment(Date.now()).format(),
			modal_obj: null,
			waived_items: [],
			waived_modal: false,
		}

		this.state.helpdesksView = 'day';
		moment.tz.setDefault("America/Phoenix");
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getHelpdesks();
	}

	getHelpdesks = async (shouldTrack = false, skipDataGrab = false) => {
		if (typeof shouldTrack === 'object' && shouldTrack !== null) {
			shouldTrack = false;
			skipDataGrab = false;
		}
		if (!skipDataGrab) {
			let model = new API.BuildClass(Types.Users_Help_Desk._name, "GET_MISSING");
			this.read = 'GET_ALL';
			model.filter = {
				//for day or week, just provide the day that they're on to grab data (week just needs it to be within that week)
				'day': this.state.filterDate,
				'filterRegions': [],
				'users': [],
				'shouldTrack': shouldTrack,
			}
			model.search = this.state.search
			this.data = await model.submit(null, "GET_MISSING");
		}
		const payload = skipDataGrab ? this.state.field_engineers : this.data?.items;
		this.data = Array.isArray(payload) ? payload : [];

		let calendars = [];
		//map through all the data to get calendars out
		for (const item of this.data) {
			if (item.calendars) {
				calendars = [...calendars, ...item.calendars];
			}
		}
		calendars.sort((a, b) => {
			return new Date(a.Start).getTime() - new Date(b.Start).getTime();
		});
		this.setState({calendars, field_engineers: this.data});
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}

	render() {
		const {calendars, pages, limit, loading} = this.state;

		const columns = [
			{
				Header: "Date",
				filterable: false,
				sortable: false,
				id: "Start",
				width: 100,
				/** @param {Calendar_Object} obj */
				accessor: obj => (moment(obj.Start).format('MM/DD/YYYY'))
			},
			{
				Header: "Client",
				filterable: false,
				sortable: false,
				id: "name",
				accessor: obj => (obj.customer_name),
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original.customer_pkey}`}>
								{props.original.customer_name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "FD Ticket #",
				filterable: false,
				sortable: false,
				id: "fresh_ticket",
				accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
				Cell: props => {
					return (
						<span>
							<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						</span>
					);
				}
			},
			{
				Header: "FE",
				filterable: false,
				sortable: false,
				id: "fe_name",
				accessor: obj => obj.fe_name
			},
			{
				Header: "FE Phone",
				filterable: false,
				sortable: false,
				id: "fe_phone",
				accessor: obj => obj.fe_phone
			},
			{
				Header: "Onsite",
				filterable: false,
				sortable: false,
				id: "on_site_time",
				accessor: obj => obj.on_site_time ? moment(obj.on_site_time).format('h:mm A') : ''
			},
			{
				Header: "Offsite",
				filterable: false,
				sortable: false,
				id: "off_site_time",
				accessor: obj => obj.off_site_time ? moment(obj.off_site_time).format('h:mm A') : ''
			},
			{
				Header: "Waived",
				id: "waived",
				Cell: (props) => {
					const obj = props.original || {};

					const waivedItems = [];

					if (obj.anti_virus_signed && obj.anti_virus_signed !== "0") waivedItems.push("Anti-Virus");
					if (obj.data_backup_signed && obj.data_backup_signed !== "0") waivedItems.push("Data Backup");
					if (obj.hdd_inspection_signed && obj.hdd_inspection_signed !== "0") waivedItems.push("HDD Inspection");
					if (obj.network_signed && obj.network_signed !== "0") waivedItems.push("Network");

					const waivedCount = waivedItems.length;
					const hasOffsite = !!obj.off_site_time;

					// No offsite or none waived → green "None"
					if (!hasOffsite || waivedCount === 0) {
						return (
							<Tooltip title="Number of 4 Point Inspections Waived" arrow>
								<span style={{
									color: "green", fontWeight: 600, width: '100%',
									height: '100%',
									display: 'flex'
								}}>
									None
								</span>
							</Tooltip>
						);
					}

					// Red clickable number
					return (
						<Tooltip title="Number of 4 Point Inspections Waived" arrow>
							<span
								style={{
									color: "red",
									fontWeight: 600,
									cursor: "pointer",
									width: '100%',
									height: '100%',
									display: 'flex'
								}}
								onClick={() =>
									this.setState({
										modal_obj: obj,
										waived_items: waivedItems,
										waived_modal: true
									})
								}
							>
								{waivedCount}
							</span>
						</Tooltip>
					);
				}
			}
			,
			{
				Header: "Amount",
				filterable: false,
				sortable: false,
				id: "amount",
				accessor: obj => (obj.finance_amount),
				width: 100,
				className: "button-cell",
				Cell: props => {
					return (
						props.original.financial_pkey ?
							<Button
								color={'primary'}
								size={"sm"} block={true}
								onClick={() => {
									this.setState({
										financial: props.original.financial_pkey,
										ticket: props.original.Ticket,
									}, () => this.handleToggleModal('showFinancialModal'));
								}}
							>
								{props.original.finance_amount}
							</Button> : null
					);
				}
			},
			{
				Header: "Review",
				id: "review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.pkey,
				Cell: props => <TicketAuditReviewLink row={props.original}/>
			},
			{
				Header: "Reviewed By",
				filterable: false,
				sortable: false,
				id: 'userChecked',
				accessor: obj => (obj.userChecked)
			},
			{
				Header: "Ticket",
				id: "ticket_review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="blue-hoki" size={"sm"} block={true} onClick={() => {
							this.setState({ticket: props.original.Ticket}, () => {
								this.handleToggleModal('showTicketModal');
							});
						}}>
							<Search fontSize={'small'}/>
						</Button>
					);
				}
			}
		]

		return (
			<div className={'box-body'}>
				<Modal
					isOpen={this.state.waived_modal}
					toggle={() => this.setState({waived_modal: false})}
					size="sm"
					backdrop
				>
					<ModalHeader toggle={() => this.setState({waived_modal: false})}>
						Waived 4-Point Inspections
					</ModalHeader>

					<ModalBody>
						{this.state.waived_items?.length === 0 ? (
							<div>None waived</div>
						) : (
							<ul style={{marginBottom: 0}}>
								{this.state.waived_items.map(item => (
									<li key={item}>{item}</li>
								))}
							</ul>
						)}
					</ModalBody>

					<ModalFooter>
						<Button
							color="secondary"
							onClick={() =>
								this.setState({
									waived_modal: false,
									modal_obj: null,
									waived_items: []
								})
							}
						>
							Cancel
						</Button>
					</ModalFooter>
				</Modal>

				<div className={"table-bar"}>
					<div className={"row"}>
						<div className={'col'}>
							<div style={{zIndex: 100, marginLeft: 0}} className={"row rbc-toolbar"}>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({field_engineers: []})
									await this.getHelpdesks();
								}}>Refresh Data
								</button>
							</div>
						</div>
					</div>
				</div>


				<ReactTable
					key={this.state.key}
					columns={columns}
					manual // Forces table not to paginate or sort automatically, so we can handle it server-side
					data={calendars}
					pages={pages} // Display the total number of pages
					loading={loading} // Display the loading overlay when we need it
					loadingText="Requesting Data"
					onFetchData={this.getHelpdesks} // Request new data when things change
					expanderDefaults={{
						sortable: true,
						resizable: true,
						filterable: false,
						width: undefined
					}}
					defaultSorted={[
						{
							id: this.model.sort,
							desc: this.model.order === 'desc'
						}
					]}
					showPagination={true}
					defaultPageSize={limit}
					className="-striped -highlight"
					onPageSizeChange={this.onPageSizeChange}
					pageSize={limit}
				/>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>


				<Framework.Elements.UniversalModal
					size={"xl"}
					title={"Help Desk Contacted"}
					object={Collections.HelpDesksContacted}
					history={this.props.history}
					toggle={this.state.help_desk_contacted_modal}
					reportClose={() => this.handleToggleModal('help_desk_contacted_modal')}
					hideGoTo={true}
					hasSubmit={false}
					objectProps={{contacted_data: this.state.helpdesk_contacted_data, forHelpdesk: true}}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					id={this.state.ticket}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					submitLabel={"Update Ticket"}
					deleteLabel={"Delete Ticket"}
					locations={[""]}
					title={"Review Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={() => this.handleToggleModal('showTicketModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
				/>
				<Framework.Elements.UniversalModal
					size={"md"}
					parent={this.state.ticket}
					id={this.state.financial}
					history={this.props.history}
					object={Objects.Financial}
					title={"Review Financial"}
					toggle={this.state.showFinancialModal}
					reportClose={() => this.handleToggleModal('showFinancialModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
					objectProps={{hideBack: true}}
				/>
			</div>
		)
	}
}
